import {Table} from "react-bootstrap";
import {useMemo} from "react";
import {getFirstWeekStartDate, getLastWeekEndDate} from "../../tools";
import MEventsCalendarCell from "./MEventsCalendarCell";

type MEventsCalendarProps = {
    selectedDay: Date;
    onDaySelect: (day: Date) => void;
}

const MEventsCalendar: React.FC<MEventsCalendarProps> = ({selectedDay, onDaySelect}) => {
    const firstViewDate = useMemo(() => getFirstWeekStartDate(selectedDay), [selectedDay]);
    const lastViewDate = useMemo(() => getLastWeekEndDate(selectedDay), [selectedDay]);

    const calendarContent = useMemo(() => {
        const calendar = [];
        let currentDay = new Date(firstViewDate);
        let week = [];
        let day = 0;

        while (currentDay <= lastViewDate) {
            if (day === 7) {
                calendar.push(
                    <tr key={"week-" + currentDay.toISOString()}>
                        {week}
                    </tr>
                );
                week = [];
                day = 0;
            }

            const isSelectedDate = currentDay.getDate() === selectedDay.getDate() && currentDay.getMonth() === selectedDay.getMonth();
            const borderWidth = isSelectedDate ? 2 : 1;
            const fontWeight = isSelectedDate ? "bold" : "normal";
            const newDate = new Date(currentDay);
            week.push(
                <td
                    onClick={event => {
                        onDaySelect(newDate);
                    }}
                    key={currentDay.toISOString()}
                    className={`text-center fw-${fontWeight} ` + (currentDay.getMonth() !== selectedDay.getMonth() ? "bg-secondary-light" : isSelectedDate ? "bg-primary-light" : "")}
                    style={{height: "50px", overflow: "hidden", border: `${borderWidth}px solid #000000`}}
                >
                    <MEventsCalendarCell day={newDate}/>
                </td>
            );
            currentDay = new Date(currentDay.setDate(currentDay.getDate() + 1));
            day++;
        }

        calendar.push(
            <tr key={"week-" + currentDay.toISOString()}>
                {week}
            </tr>
        );

        return calendar;
    }, [firstViewDate, lastViewDate, selectedDay, onDaySelect]);


    return (
        <Table size={"sm"} bordered>
            <thead>
            <tr>
                <th className={"text-center"} style={{width: "14%"}}>Пон</th>
                <th className={"text-center"} style={{width: "14%"}}>Вто</th>
                <th className={"text-center"} style={{width: "14%"}}>Сря</th>
                <th className={"text-center"} style={{width: "14%"}}>Чет</th>
                <th className={"text-center"} style={{width: "14%"}}>Пет</th>
                <th className={"text-center"} style={{width: "14%"}}>Съб</th>
                <th className={"text-center"} style={{width: "14%"}}>Нед</th>
            </tr>
            </thead>

            <tbody>
            {calendarContent}
            </tbody>

        </Table>
    );
};

export default MEventsCalendar;
